'use strict';

module.exports = 2147483647;



//////////////////
// WEBPACK FOOTER
// ./~/timers-ext/max-timeout.js
// module id = 532
// module chunks = 0